module.exports = __webpack_public_path__ + "img/success.b7dd72d4.png";